import { useApi, useCurrentUser } from 'lib/contexts/ApplicationState';
import { useSignUpModal } from 'components/SignUpModal';
import { SaveToProjectListModal } from 'components/SaveToList/SaveToProjectListModal';
import { useModal } from 'mui-modal-provider';
import { ContentListsItemType } from 'lib/types';
import { trackClickSignupEvent } from 'lib/hooks/useEventTracking';

interface Props {
  itemId: number;
  itemType: ContentListsItemType;
  text?: string;
  styling?: string;
  context: 'project' | 'list';
  excludePersonal?: boolean;
}

export const SaveToProjectListButton = ({
  itemId, itemType, text, styling, context, excludePersonal = false,
}: Props) => {
  const currentUser = useCurrentUser();
  const API = useApi();
  const { showSignUpModal } = useSignUpModal();
  const { showModal } = useModal();

  const click = () => {
    if (!currentUser) {
      trackClickSignupEvent(API, 'save-to-project-list');
      showSignUpModal(`Please sign up or sign in to save ${itemType}s`);
      return;
    }
    const modal = showModal(SaveToProjectListModal, {
      itemId,
      itemType,
      onClose: () => {
        modal.destroy();
      },
      context,
      excludePersonal,
    });
  };

  return (
    <div className="object-cover w-full">
      <button
        type="button"
        onClick={click}
        className={styling || 'hover:bg-hintgray hover:dark:bg-darkgray/50 rounded-full w-full text-left'}
      >
        {text || 'Add post to project'}
      </button>
    </div>
  );
};
